export default __webpack_public_path__ + "static/media/cs_contact_center_mega_menu.df408952.png";